import { Link } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { separationApi } from '../../api/separation';
import { ApiError } from '../../api/client';
import { StatusBadge } from '../../components/StatusBadge';
import { DataTable } from '../../components/DataTable';
import { ReturnedBanner } from '../../components/ReturnedBanner';
import { useToast } from '../../components/Toast';

const STATUS_LABELS: Record<string, string> = { draft: 'Draft', submitted: 'Submitted', under_review: 'Under Review', returned: 'Returned for Redraft', approved: 'Approved', rejected: 'Rejected', completed: 'Completed', cancelled: 'Cancelled' };

export function MySeparationPage() {
  const { showSuccess, showError } = useToast();
  const queryClient = useQueryClient();

  const mineQuery = useQuery({ queryKey: ['my-separation'], queryFn: () => separationApi.mine() });
  const submitMutation = useMutation({ mutationFn: (id: number) => separationApi.submit(id), onSuccess: () => { showSuccess('Submitted.'); queryClient.invalidateQueries({ queryKey: ['my-separation'] }); }, onError: (err) => showError(err instanceof ApiError ? err.message : 'Failed.') });

  return (
    <div className="page">
      <Link to="/staff">&larr; Back to Dashboard</Link>
      <h1>My Separation</h1>

      <section className="card">
        {mineQuery.data && (
          <DataTable
            rows={mineQuery.data.data}
            rowKey={(r) => r.id}
            emptyMessage="No separation case on file."
            columns={[
              { header: 'Reference', render: (r) => r.separation_reference },
              { header: 'Last Working Day', render: (r) => r.last_working_day },
              { header: 'Status', render: (r) => <StatusBadge status={r.status} label={STATUS_LABELS[r.status]} /> },
              { header: '', render: (r) => r.status === 'draft' && <button className="link-button" onClick={() => submitMutation.mutate(r.id)}>Submit</button> },
            ]}
          />
        )}
        {mineQuery.data?.data.filter((r) => r.status === 'returned').map((r) => (
          <ReturnedBanner key={r.id} returnComment={r.return_comment} resubmit={() => separationApi.resubmit(r.id)} queryKeysToInvalidate={[['my-separation']]} />
        ))}
      </section>
    </div>
  );
}
